/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OpportunityDatafile
 */
export interface OpportunityDatafile {
  /**
   *
   * @type {string}
   * @memberof OpportunityDatafile
   */
  fileName: string;
  /**
   *
   * @type {string}
   * @memberof OpportunityDatafile
   */
  contentType?: string;
  /**
   *
   * @type {string}
   * @memberof OpportunityDatafile
   */
  base64Content: string;
}

/**
 * Check if a given object implements the OpportunityDatafile interface.
 */
export function instanceOfOpportunityDatafile(
  value: object,
): value is OpportunityDatafile {
  if (!("fileName" in value) || value["fileName"] === undefined) return false;
  if (!("base64Content" in value) || value["base64Content"] === undefined)
    return false;
  return true;
}

export function OpportunityDatafileFromJSON(json: any): OpportunityDatafile {
  return OpportunityDatafileFromJSONTyped(json, false);
}

export function OpportunityDatafileFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityDatafile {
  if (json == null) {
    return json;
  }
  return {
    fileName: json["fileName"],
    contentType: json["contentType"] == null ? undefined : json["contentType"],
    base64Content: json["base64Content"],
  };
}

export function OpportunityDatafileToJSON(json: any): OpportunityDatafile {
  return OpportunityDatafileToJSONTyped(json, false);
}

export function OpportunityDatafileToJSONTyped(
  value?: OpportunityDatafile | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    fileName: value["fileName"],
    contentType: value["contentType"],
    base64Content: value["base64Content"],
  };
}
